import { render, staticRenderFns } from "./ReturnedInventoryRequest.vue?vue&type=template&id=b20011ca&scoped=true&"
import script from "./ReturnedInventoryRequest.vue?vue&type=script&lang=js&"
export * from "./ReturnedInventoryRequest.vue?vue&type=script&lang=js&"
import style0 from "./ReturnedInventoryRequest.vue?vue&type=style&index=0&id=b20011ca&prod&lang=scss&scoped=true&"
import style1 from "./ReturnedInventoryRequest.vue?vue&type=style&index=1&id=b20011ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20011ca",
  null
  
)

export default component.exports